import { Controller } from '@hotwired/stimulus';

import GridyCommon from '@/modules/gridy_common';
import I18n from '@/modules/i18n';
import ModuleLoader from '@/modules/module_loader';
import Templates from '@/pages/common/templates';

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    GridyCommon.gridy($('[data-gridy]'), {
      find: 'name',

      headers: [
        { name: I18n.t('name'), value: 'name' },
        { name: I18n.t('code'), value: 'code' },
        { name: I18n.t('percentage.one'), value: 'percentage_cents' },
        { name: I18n.t('amount'), value: 'amount_cents' },
        { name: I18n.t('expires_at'), value: 'expires_at' },
        { name: I18n.t('menu.one'), value: '' },
      ],

      sortName: 'name',
      template: Templates.coupons.gridy,
      url: options.gridy.url,
    });
  }
}
